import {
	FaBook,
	FaCalculator,
	FaClock,
	FaEnvelope,
	FaMapMarkedAlt,
	FaMapMarkerAlt,
	FaPhoneAlt,
	FaUserCircle,
} from 'react-icons/fa';

export const BtnData = [
	{
		id: 0,
		img: require('../images/course.jpg'),
		title: 'Course',
		NaviPage: '/Course',
	},
	{
		id: 1,
		img: require('../images/services.jpg'),
		title: 'Services',
		NaviPage: '/Service',
	},
	{
		id: 2,
		img: require('../images/contact.jpg'),
		title: 'Contact',
		NaviPage: '/Contact',
	},
	{
		id: 3,
		img: require('../images/about.jpeg'),
		title: 'About',
		NaviPage: '/About',
	},
];

export const carousel1 = [
	{
		id: 0,
		image: require('../images/img-2.jpg'),
		headertxt: 'KANASU EDUCATIONAL AND CHARITABLE TRUST',
		para: 'Skills for your present and your future.Get started with us.',
		btntxt: 'Our Course',
		navi: '/Course',
	},
	{
		id: 1,
		image: require('../images/img-1.jpg'),
		headertxt: 'OBJECTIVES OF THE TRUST',
		para: 'we believe that knowledge and access to government services are equally vital for personal growth and community development.',
		btntxt: 'Our Services',
		navi: '/Service',
	},
	{
		id: 2,
		image:
			'https://wallpapers.com/images/hd/white-house-nature-mr9os12bx8mlrbcm.jpg',
		headertxt: 'ABOUT US',
		para: ' we conduct workshops and training sessions focused on personal development, employability skills, and entrepreneurship to equip individuals with essential life skills.',
		btntxt: 'About Us',
		navi: '/About',
	},
];

export const contactList = [
	{
		id: 4,
		icon: <FaMapMarkerAlt color="#3c3ddc" />,
		text: 'Post Office Road,  <br /> Nelamangala, Indiranagara, <br />Karnataka 562123',
	},
	{
		id: 5,
		icon: <FaClock color="#f5812d" />,

		text: 'Mon-Sat : 8AM-8PM <br />Sunday : 8AM-1PM',
	},
	{
		id: 6,
		icon: <FaPhoneAlt color="#3c3ddc" />,

		text: '8884264377',
	},
	{
		id: 7,
		icon: <FaEnvelope color="#f5812d" />,

		text: 'kanasucyber128@gmail.com',
	},
];

export const aboutList = [
	{
		id: 0,
		icon: <FaBook color="#3c3ddc" />,
		text: 'Best Education',
	},
	{
		id: 1,
		icon: <FaCalculator color="#3c3ddc" />,
		text: 'Affordable',
	},
	{
		id: 2,
		icon: <FaMapMarkedAlt color="#f5812d" />,
		text: 'Friendly Place',
	},
	{
		id: 3,
		icon: <FaUserCircle color="#f5812d" />,
		text: 'Qualified Staff',
	},
];

export const CourseData = [
	{
		id: 1,
		title: 'COM',
		sub_title: 'Certificate in Microsoft Office',
		eligibility: '8th Class',
		duration: '3 Months',
		content: [
			'Computer Concept & Fundamental',
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'Internet Technology & Multimedia',
		],
	},
	{
		id: 2,
		title: 'C/C++',
		sub_title: 'Certificate in C/C++',
		eligibility: '9th Class',
		duration: '3 Months',
		content: [
			'Operating System: (Windows 2000/Xp/7/10)',
			'C Programming',
			'C++',
		],
	},
	{
		id: 3,
		title: 'DIPWD',
		sub_title: 'Dipl. in Programming & Web Desigining',
		eligibility: '10th Class',
		duration: '6 Months',
		content: [
			'Computer Concept & Fundamental',
			'Microsoft Office',
			'C Programming',
			'HTML',
			'Animation',
			'Basic website',
			'Internet & Project Work',
		],
	},
	{
		id: 4,
		title: 'DOAM',
		sub_title: 'Diploma in Office Automation & Management',
		eligibility: '12th Class',
		duration: '6 Months',
		content: [
			'Computer Concept & Fundamental',
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'Tally Prime',
			'Business Communication',
			'Internet Technology',
		],
	},
	{
		id: 5,
		title: 'DCOM',
		sub_title: 'Diploma in Computer office Management',
		eligibility: '12th Class',
		duration: '1 Year',
		content: [
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'Adobe Photoshop',
			'Tally Prime',
			'Introduction to Accounting',
			'Final Accounts',
			'C Language',
		],
	},
	{
		id: 6,
		title: 'PGDCA',
		sub_title: 'PG Diploma in Computer Application',
		eligibility: '12th Class',
		duration: '1 Year',
		content: [
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'DTP',
			'Graphics with Visual Basic (VBA)',
			'Programming in C++',
			'Programming in C',
			'Programming in JAVA',
			'Project Work',
		],
	},
	{
		id: 7,
		title: 'ADCA',
		sub_title: 'Advance Diploma in Computer Application',
		eligibility: '12th Class',
		duration: '1 Year',
		content: [
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'Tally Prime',
			'DTP',
			'Business Communication',
			'Internet Technology',
			'Graphics with Visual Basic (VBA)',
			'Programming in C++',
			'Programming in C',
			'Programming in JAVA',
			'Project Work',
		],
	},
];

export const CourseFew = [
	{
		id: 1,
		title: 'PGDCA',
		sub_title: 'PG Diploma in Computer Application',
		eligibility: '12th Class',
		duration: '1 Year',
		content: [
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'DTP',
			'Graphics with Visual Basic (VBA)',
			'Programming in C++',
			'Programming in C',
			'Programming in JAVA',
			'Project Work',
		],
	},
	{
		id: 2,
		title: 'ADCA',
		sub_title: 'Advance Diploma in Computer Application',
		eligibility: '12th Class',
		duration: '1 Year',
		content: [
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'Tally Prime',
			'DTP',
			'Business Communication',
			'Internet Technology',
			'Graphics with Visual Basic (VBA)',
			'Programming in C++',
			'Programming in C',
			'Programming in JAVA',
			'Project Work',
		],
	},
	{
		id: 3,
		title: 'DOAM',
		sub_title: 'Diploma in Office Automation & Management',
		eligibility: '12th Class',
		duration: '6 Months',
		content: [
			'Computer Concept & Fundamental',
			'Operating System: DOS | Windows - 2000/XP',
			'MS Office: MS-Word | MS-Excel | MS-Access | MS-Outlook | MS-Power Point',
			'Tally Prime',
			'Business Communication',
			'Internet Technology',
		],
	},
];

export const ServiceData = [
	{ id: 1, title: 'All Types of Xerox & Scanning Done Here' },
	{ id: 2, title: 'Lamination' },
	{ id: 3, title: 'Online Applications' },
	{ id: 4, title: 'Ration Card' },
	{ id: 5, title: 'Pan Card' },
	{ id: 6, title: 'Pahani and Mutation' },
	{ id: 7, title: 'Aadhar Card Printout' },
	{ id: 8, title: 'Aadhar Correction' },
	{ id: 9, title: 'Voter ID' },
	{ id: 10, title: 'PF Online Apply' },
	{ id: 11, title: 'Bus Ticket Booking' },
	{ id: 12, title: 'Bus Pass' },
	{ id: 13, title: 'Scholarships' },
	{ id: 14, title: 'Senior Citizen Card' },
	{ id: 15, title: 'English & Kannada Typing' },
	{ id: 16, title: 'Pan Correction' },
];

export const GoverningData = [
	{
		id: 0,
		name: 'SMT. Veena',
		title: 'Chairman',
		image: require('../images/veena.jpg'),
		decp: "In this digital age, technology isn't just a tool; it's a lifeline to endless possibilities.",
		explination:
			'The quote encapsulates the profound influence of technology in our modern world. Today, technology is not limited to being a mere tool; it has become an integral part of our daily lives, transforming the way we work, communicate, learn, and interact with the world. It serves as a lifeline, connecting us to a vast realm of information, knowledge, and opportunities. The advancements in digital technology have revolutionized industries, opened up new avenues for creativity and innovation, and facilitated global connectivity like never before. Embracing technology and understanding its potential is vital in leveraging the opportunities it presents and adapting to the fast-paced changes of the digital era.',
	},
	{
		id: 1,
		name: 'SRI. Saif',
		title: 'Secretary',
		image: require('../images/saif.jpg'),
		decp: 'Empowering Minds, Enriching Lives: Together, through Kanasu Educational & Charitable Trust, we nurture dreams, illuminate knowledge, and uplift communities for a brighter tomorrow.',
		explination:
			"The essence of Kanasu Educational & Charitable Trust's mission. Through our collective efforts, we empower individuals with knowledge and skills, enabling them to dream big and reach their full potential. By illuminating minds and offering educational opportunities, we strive to enrich the lives of those we serve and uplift communities, fostering a brighter and more promising future for all.",
	},
	{
		id: 2,
		name: 'SRI. Vikas M R',
		title: 'Treasurer',
		image: require('../images/vikas.jpg'),
		decp: 'Knowledge for All, Impacting Communities: Kanasu Educational & Charitable Trust, delivering government services and computer education for a stronger society.',
		explination:
			"The trust is committed to making knowledge accessible to all by delivering government services and computer education. Through these initiatives, the trust impacts communities and contributes to building a stronger and more resilient society. The quote reflects the trust's mission of providing essential resources and skills that empower individuals to lead more informed and enriched lives, positively influencing the broader community.",
	},
];
